import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

const Header = () => {
    return (
        <header id="header" className="header fixed-top d-flex align-items-center">

            <div className="d-flex align-items-center justify-content-between">
                <a href={process.env.REACT_APP_PATH_APP} className="logo d-flex align-items-center">
                    <img src="assets/img/logo.png" alt="" />
                    <span className="d-none d-lg-block">
                        <FontAwesomeIcon
                            icon={faHome}
                        />
                    </span>
                </a>
            </div>

             <nav className="header-nav ms-auto">
                <label><span style={{fontWeight: "bold"}}>Portal de aplicaciones - Versión: 1.02</span>&nbsp;&nbsp;</label>            
            </nav>

        </header>

    )
}

export default Header;